import css from "standard/css";

const style = css`
  :root {
    --border-radius-none: 0;
    --border-radius-xs: 4px;
    --border-radius-sm: 8px;
    --border-radius-md: 16px;
    --border-radius-lg: 24px;
    --border-radius-pill: 500px;
    --border-radius-circular: 50%;
  }
`;

export default style;
